import { useContext, useState } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { Banner } from "../Banners";
import { Env } from "../../../collector";
import { Button, Modal } from "react-bootstrap";
import Switch from "../../../components/Switch/Switch";


interface CreateBannerProps {
    createBanner: (banner: Banner) => void;
    environment: Env;
}

export function CreateBannerModal(props: CreateBannerProps) {
    const [show, setShow] = useState<boolean>(false);
    const [banner, setBanner] = useState<Banner>({
        id: 0,
        enabled: false,
        description: "",
        heading: "",
        body: [],
        btns: [],
        color: "#ffffff",
        fontColor: "#000000"
    });
    const { token } = useContext(AuthContext);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
        setBanner({
            id: 0,
            enabled: false,
            description: "",
            heading: "",
            body: [],
            btns: [],
            color: "#ffffff",
            fontColor: "#000000"
        });
    };

    return (
        <>
            <Button variant='outline-dark' onClick={() => handleShow()}>
                Create Banner
            </Button>
            {show &&
                <Modal
                    show={show}
                    backdrop="static"
                    onHide={() => handleClose()}
                    keyboard={false}
                >
                    <form onSubmit={(e) => {
                        e.preventDefault();
                        props.createBanner(banner);
                    }}>
                        <Modal.Header closeButton>
                            <Modal.Title>Create Banner</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="dialog-data-field">
                                <span>Description:</span>
                                <input type="text" value={banner.description} required onChange={(item) => setBanner({ ...banner, description: item.target.value })} />
                            </div>
                            <div className="dialog-data-field">
                                <span>Banner Color:</span>
                                <input type="color" value={banner.color} onChange={(item) => setBanner({ ...banner, color: item.target.value })} />
                            </div>
                            <div className="dialog-data-field">
                                <span>Font Color:</span>
                                <input type="color" value={banner.fontColor} onChange={(item) => setBanner({ ...banner, fontColor: item.target.value })} />
                            </div>
                            <div className="dialog-data-field">
                                <span>Banner Header:</span>
                                <input type="text" value={banner.heading ?? ''} onChange={(item) => setBanner({ ...banner, heading: item.target.value })} />
                            </div>
                            <div className="dialog-data-field">
                                <span>Banner Body:</span>
                                <div style={{ display: 'flex', flexDirection: 'column', rowGap: '5px' }}>
                                    <div style={{ display: 'flex' }}>
                                        <Button style={{ marginLeft: 'auto', width: '35px' }} variant="secondary" onClick={() => {
                                            let temp = { ...banner };
                                            temp.body.push("");
                                            setBanner(temp);
                                        }}>+</Button>
                                        <Button style={{ marginLeft: '3px', width: '35px' }} variant="secondary" onClick={() => {
                                            let temp = { ...banner };
                                            temp.body.pop();
                                            setBanner(temp);
                                        }}>-</Button>
                                    </div>
                                    {banner.body.map((line, index) => {
                                        return (
                                            <input key={index} type="text" value={line}
                                                onChange={(item) => {
                                                    let temp = { ...banner };
                                                    temp.body[index] = item.target.value;
                                                    setBanner(temp);
                                                }}
                                            />
                                        )
                                    })}
                                </div>
                            </div>
                            <div className="dialog-data-field">
                                <span>Banner Buttons:</span>
                                <div style={{ display: 'flex', flexDirection: 'column', rowGap: '5px' }}>
                                    <div style={{ display: 'flex' }}>
                                        <Button style={{ marginLeft: 'auto', width: '35px' }} variant="secondary" onClick={() => {
                                            let temp = { ...banner };
                                            temp.btns.push({ link: '', text: '', color: '#ffffff', fontColor: '#000000' });
                                            setBanner(temp);
                                        }}>+</Button>
                                        <Button style={{ marginLeft: '3px', width: '35px' }} variant="secondary" onClick={() => {
                                            let temp = { ...banner };
                                            temp.btns.pop();
                                            setBanner(temp);
                                        }}>-</Button>
                                    </div>
                                    {banner.btns.map((btn, index) => {
                                        return (
                                            <div key={index} style={{ display: 'flex', flexDirection: 'column', rowGap: '3px', marginBottom: '7px' }}>
                                                <div style={{ display: 'flex', columnGap: '5px', justifyContent: 'flex-end' }}>
                                                    <span>Button {index + 1} Link:</span>
                                                    <input style={{ right: '0' }} key={index} type="text" value={btn.link}
                                                        onChange={(item) => {
                                                            let temp = { ...banner };
                                                            temp.btns[index].link = item.target.value;
                                                            setBanner(temp);
                                                        }}
                                                    />
                                                </div>
                                                <div style={{ display: 'flex', columnGap: '5px', justifyContent: 'flex-end' }}>
                                                    <span>Button {index + 1} Text:</span>
                                                    <input style={{ right: '0' }} key={index} type="text" value={btn.text}
                                                        onChange={(item) => {
                                                            let temp = { ...banner };
                                                            temp.btns[index].text = item.target.value;
                                                            setBanner(temp);
                                                        }}
                                                    />
                                                </div>
                                                <div style={{ display: 'flex', columnGap: '5px', justifyContent: 'flex-end' }}>
                                                    <span>Button {index + 1} Color:</span>
                                                    <input style={{ right: '0' }} key={index} type="color" value={btn.color}
                                                        onChange={(item) => {
                                                            let temp = { ...banner };
                                                            temp.btns[index].color = item.target.value;
                                                            setBanner(temp);
                                                        }}
                                                    />
                                                </div>
                                                <div style={{ display: 'flex', columnGap: '5px', justifyContent: 'flex-end' }}>
                                                    <span>Button {index + 1} Font Color:</span>
                                                    <input style={{ right: '0' }} key={index} type="color" value={btn.fontColor}
                                                        onChange={(item) => {
                                                            let temp = { ...banner };
                                                            temp.btns[index].fontColor = item.target.value;
                                                            setBanner(temp);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                            <div className="dialog-data-field">
                                <span>Enabled:</span>
                                <Switch checked={banner.enabled} onChange={(item) => setBanner({ ...banner, enabled: item.target.checked })} />
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => handleClose()}>
                                Close
                            </Button>
                            <Button variant="primary" type='submit'>Create Banner</Button>
                        </Modal.Footer>
                    </form>
                </Modal >
            }
        </>
    );

}
